import { render, staticRenderFns } from "./AddValue.vue?vue&type=template&id=48121e9f&scoped=true"
import script from "./AddValue.vue?vue&type=script&lang=js"
export * from "./AddValue.vue?vue&type=script&lang=js"
import style0 from "./AddValue.vue?vue&type=style&index=0&id=48121e9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48121e9f",
  null
  
)

export default component.exports